<div class="modal-header">
	<button type="button" class="close" aria-label="Close" (click)="close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="text-center" *ngIf="loaders.dataSource && historyLength > 1">
	<button mat-raised-button color="accent" class="margin-buttons-form-field" (click)="switchCompareView()">
		&nbsp;
		<ng-container *ngIf="!compareView; else elseTemplate">
			Compare Views
		</ng-container>
		<ng-template #elseTemplate>
			<ng-container *ngIf="ids.length > 0">
				Last Processed
			</ng-container>
			<ng-container *ngIf="ids.length == 0">
				Last Received
			</ng-container>
			
		</ng-template>
		&nbsp;
	</button>
</div>
<!-- Loader spinner begins -->
<div *ngIf="!loaders.dataSource" class="pt-5 kt-spinner kt-spinner--center kt-spinner--lg kt-spinner--dark">
</div>
<div class="row">
<div class="col-2"></div>
<div  *ngIf="loaders.dataSource" class="col-8">
		    <mat-table class="table table-striped " [dataSource]="dataSource"  matSortDirection="asc">
                <!-- orderType column -->
                <ng-container matColumnDef="orderType">
                    <mat-header-cell *matHeaderCellDef  class="align-left"> Type of Document </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="align-left">                    	
                    	Purchase Order	{{
							(element.orderType?.trim().toUpperCase() === 'PD')
							  ? 'Cancel'
							  : element.orderType
						  }}            	
                    </mat-cell>
                </ng-container>

				<!-- systemDate column -->
				<ng-container matColumnDef="systemDate">
					<mat-header-cell *matHeaderCellDef  class="align-left" > Date Received</mat-header-cell>
					<mat-cell *matCellDef="let element" class="align-left">				
						
							{{element.systemDate | date:'yyyy-MM-dd HH:mm'}}
						
					</mat-cell>
				</ng-container>  
				<!-- systemDate column -->
				<ng-container matColumnDef="orderStatus">
                    <mat-header-cell *matHeaderCellDef  class="align-left"> Status </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="align-left">     
						<span [ngClass]="{
										status: true,
										green: element.orderStatus === 'P',
										yellow: element.orderStatus === ' ',
										orange: element.orderStatus === 'C' ,
										dark: element.orderStatus === 'D' || element.orderStatus === 'L' || element.orderStatus === 'Z'
										
									}">
							{{element.orderStatus == 'P' ? 'Processed' : 
								element.orderStatus === ' ' ? 'Unprocessed' : 
								element.orderStatus === 'C' ? 'Canceled' : 
								element.orderStatus === 'D' ? 'Deleted' : 
								element.orderStatus === 'L' ? 'Delayed POC' : 
								element.orderStatus === 'Z' ? 'Delayed POC' :
								'-'}} 
						</span>               	
                    		                   	
                    </mat-cell>
                </ng-container>
				<!-- systemDate column -->
				<ng-container matColumnDef="orderNumber">
                    <mat-header-cell *matHeaderCellDef  class="align-left"> Order Number </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="align-left">
        				<ng-container *ngIf="element.orderList && element.orderList.length > 0; else noOrders">
           					 <span *ngFor="let order of element.orderList; let last = last">
                				{{ order.orderNumber }}<span *ngIf="!last">, </span>
            				</span>
        				</ng-container>
       				 	<ng-template #noOrders>
            			<span>-</span>
        				</ng-template>
    				</mat-cell>
                </ng-container>
                
                <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" class="input-container"></mat-row>
            </mat-table>
</div>
<div class="col-2"></div>
</div>

<!-- Loader spinner ends -->
<div class="modal-body complete" *ngIf="!compareView && loaders.dataSource">
	<div class="pdf-viewer-controls-wrap">

		<div class="pdf-viewer-controls row">
		  <div class="pdfv-control col-8" *ngIf="renderText">
			Search:
			<input #queryInp id="pdfQueryInput" type="text" placeholder="Search..." [value]="pdfQuery"
			  (input)="searchQueryChanged($event.target.value)" (keyup.enter)="searchQueryChanged(queryInp.value)">
			</div>
			<div class="col-2">Total Pages:{{totalPages}}</div>
			<div class="col-2">
				<span matTooltip="Zoom Out" > <i class="fa fa-minus-square fa-lg" aria-hidden="true" (click)="zoomOut()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Zoom In" > <i class="fa fa-plus-square fa-lg" aria-hidden="true" (click)="zoomIn()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Rotate"> <i class="fa fa-undo fa-lg" aria-hidden="true" (click)="rotateDoc()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Print"> <i class="fa fa fa-print fa-lg" aria-hidden="true" (click)="printPDF()"></i> </span>
			</div>

		</div>
	  </div>
	  <div class="pdf-viewer-viewer-window">
		<pdf-viewer  [src]="pathNormalView" [downloadFileName]="name" [render-text]="renderText" [render-text-mode]="renderTextMode" [rotation]="rotation"
		[zoom]="zoom" [zoom-scale]="zoomScale" [original-size]="originalSize" [fit-to-page]="fitToPage"
		[show-all]="showAll" [autoresize]="autoresize" (after-load-complete)="callBackFn($event)"
		 (error)="onError($event)" >
	  </pdf-viewer>

	  </div>

</div>
<div class="modal-body" *ngIf="compareView">

	<h4>Last Received: {{ lastChangeString | date:'MM/dd/yyyy h:mm:ss' }}</h4>
	<!-- Loader spinner begins -->
	<div *ngIf="!loaders.pdfSource1" class="pt-5 kt-spinner kt-spinner--center kt-spinner--lg kt-spinner--dark">
	</div>
	<!-- Loader spinner ends -->
	<div class="pdf-viewer-controls-wrap">

		<div class="pdf-viewer-controls row">
		  <div class="pdfv-control col-8" *ngIf="renderText">
			Search:
			<input #queryInp id="pdfQueryInput" type="text" placeholder="Search..." [value]="pdfQuery1"
			  (input)="searchQueryChanged1($event.target.value)" (keyup.enter)="searchQueryChanged1(queryInp.value)">
			</div>
			<div class="col-2">Total Pages:{{totalPages1}}</div>
			<div class="col-2">
				<span matTooltip="Zoom Out" > <i class="fa fa-minus-square fa-lg" aria-hidden="true" (click)="zoomOut1()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Zoom In" > <i class="fa fa-plus-square fa-lg" aria-hidden="true" (click)="zoomIn1()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Rotate"> <i class="fa fa-undo fa-lg" aria-hidden="true" (click)="rotateDoc1()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Print"> <i class="fa fa fa-print fa-lg" aria-hidden="true" (click)="printPDF1()"></i> </span>
			</div>

		</div>
	  </div>
	  <div class="pdf-viewer-viewer-window">
		<pdf-viewer  *ngIf="loaders.pdfSource1" [src]="pathCompareView1" [downloadFileName]="name1" [render-text]="renderText1" [render-text-mode]="renderTextMode1" [rotation]="rotation1"
		[zoom]="zoom1" [zoom-scale]="zoomScale1" [original-size]="originalSize1" [fit-to-page]="fitToPage1"
		[show-all]="showAll1" [autoresize]="autoresize1" (after-load-complete)="callBackFn1($event)"
		 (error)="onError($event)" >
	  </pdf-viewer>

	  </div>

</div>
<div class="modal-body top-position" *ngIf="compareView">
	<mat-form-field appearance="fill">
		<mat-label class="mat-label">PO 2</mat-label>
		<mat-select (ngModelChange)="updatePDF($event, 'second')" [(ngModel)]="selected2Value">
			<mat-option [value]="item.id" *ngFor="let item of history">
				{{ item.orderType }} PO - {{ item.systemDate | date:'MM/dd/yyyy h:mm:ss' }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<h4 *ngIf="loaders.pdfSource2">{{ po2OrderTypeString }} {{ po2DateString | date:'MM/dd/yyyy h:mm:ss' }}</h4>
	<!-- Loader spinner begins -->
	<div *ngIf="!loaders.pdfSource2" class="pt-5 kt-spinner kt-spinner--center kt-spinner--lg kt-spinner--dark">
	</div>
	<!-- Loader spinner ends -->
	<div class="pdf-viewer-controls-wrap">

		<div class="pdf-viewer-controls row">
		  <div class="pdfv-control col-8" *ngIf="renderText">
			Search:
			<input #queryInp id="pdfQueryInput" type="text" placeholder="Search..." [value]="pdfQuery2"
			  (input)="searchQueryChanged2($event.target.value)" (keyup.enter)="searchQueryChanged2(queryInp.value)">
			</div>
			<div class="col-2">Total Pages:{{totalPages}}</div>
			<div class="col-2">
				<span matTooltip="Zoom Out" > <i class="fa fa-minus-square fa-lg" aria-hidden="true" (click)="zoomOut2()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Zoom In" > <i class="fa fa-plus-square fa-lg" aria-hidden="true" (click)="zoomIn2()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Rotate"> <i class="fa fa-undo fa-lg" aria-hidden="true" (click)="rotateDoc2()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Print"> <i class="fa fa fa-print fa-lg" aria-hidden="true" (click)="printPDF2()"></i> </span>
			</div>

		</div>
	  </div>
	  <div class="pdf-viewer-viewer-window">
		<pdf-viewer  *ngIf="loaders.pdfSource2" [src]="pathCompareView2" [downloadFileName]="name2" [render-text]="renderText2" [render-text-mode]="renderTextMode2" [rotation]="rotation2"
		[zoom]="zoom2" [zoom-scale]="zoomScale2" [original-size]="originalSize2" [fit-to-page]="fitToPage2"
		[show-all]="showAll2" [autoresize]="autoresize2" (after-load-complete)="callBackFn2($event)"
		 (error)="onError($event)" >
	  </pdf-viewer>

	  </div>
</div>
